import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import "./Login.scss";
import axios from "axios";
import { apiUrl } from "../../consts/consts";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userEmailError, setUserEmailError] = useState("");
  const [userPasswordError, setUserPasswordError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("Impact")) {
      navigate("/publishers");
    }
  }, []);

  const notifyWarning = (message) =>
    toast.error(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      className: "toast-message",
    });

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  async function handleLogin() {
    try {
      const response = await axios.post(`${apiUrl}/login`, {
        email: userEmail,
        password: userPassword,
      });
      localStorage.setItem("Impact", response.data.token);

      if (response.data.token) {
        navigate("/publishers");
      }
    } catch (error) {
      if (!userEmail) {
        setUserEmailError("Please provide a valid email");
        notifyWarning(userEmailError);
      }
      if (!userPassword) {
        setUserPasswordError("Please provide a valid password");
        notifyWarning(userPasswordError);
      } else {
        notifyWarning(`Login failed. \n Incorrect email or password.`);
      }
    }
  }

  return (
    <div className="wrapper">
      <div className="card">
        <div id="logo"></div>
        <div className="login-form" onKeyPress={handleKeyPress}>
          <br />
          <br />
          <label htmlFor="">Email</label>
          <input
            onChange={(e) => setUserEmail(e.target.value)}
            type="email"
            onKeyPress={handleKeyPress}
            placeholder="Type your email"
            value={userEmail}
          />
          <br />
          <label htmlFor="">Password</label>
          <input
            onChange={(e) => setUserPassword(e.target.value)}
            type="password"
            onKeyPress={handleKeyPress}
            placeholder="Type your password"
            value={userPassword}
          />
          <p>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={() => navigate("/password/reset")}>Forgot password</a>
          </p>
          <br />
          <button
            className="action-button"
            onKeyPress={handleKeyPress}
            onClick={handleLogin}
            type="submit"
          >
            Login
          </button>
          <br />
          <div className="request-account">
            <p>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="mailto:support@weborama.nl?subject=Accountaanvraag Impact Marketplace">
                Request an account
              </a>
            </p>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default Login;
